<template lang="pug">
  section.login-section
    b-loading(v-bind:active.sync="isLoading")
    .login-wrapper.columns.is-desktop(v-bind:class="{'is-hom': isHom}")
      .column.is-6-desktop.is-11-tablet
        section.hero.is-fullheight
          .hero-heading
            .section.has-text-centered
              img(src='~@/assets/logo.svg', alt='Logo', width='70%')
          .hero-body
            .container
              h1.title.is-2.has-text-centered.section Autenticação
              .content(v-if="isHom")
                h2.subtitle.is-5.has-text-centered HOMOLOGAÇÃO
              form.login-form(v-on:submit.prevent="login")
                b-field(label="Email ou Nome de Usuário" v-bind:message="errors.first('username')" v-bind:type="isDanger('username')")
                  b-input.email-input(type="text" icon="person" v-model="credentials.username" v-validate="validations.username" name="username" data-vv-as="Email ou Nome de Usuário")
                b-field(label="Senha" v-bind:message="errors.first('password')" v-bind:type="isDanger('password')")
                  b-input.password-input(type="password" icon="lock" v-model="credentials.password" password-reveal v-validate="validations.password" name="password" data-vv-as="senha")
                p.control.login
                  button.button.is-primary.is-large(type="submit") Login
              .section.forgot-password
                p.has-text-centered
                  a(@click="forgotPasswordModalActive = true") Esqueci a Senha
                  a(@click="helpModalActive = true") Ajuda
                b-modal(:active.sync="helpModalActive" has-modal-card)
                  help-modal
                b-modal(:active.sync="forgotPasswordModalActive" has-modal-card)
                  forgot-password-modal
                b-modal(:active.sync="resetPasswordModalActive" has-modal-card)
                  reset-password-modal(v-bind:token="routeParams.token")
</template>

<script>
  import AuthService from '@/services/auth'
  import SetupService from '@/services/setup'

  import HelpModal from './components/HelpModal'
  import ForgotPasswordModal from './components/ForgotPasswordModal'
  import ResetPasswordModal from './components/ResetPasswordModal'

  export default {
    name: 'auth',
    components: {
      HelpModal,
      ForgotPasswordModal,
      ResetPasswordModal
    },
    data () {
      return {
        isHom: !!(process.env.IS_HOM),
        forgotPasswordModalActive: false,
        helpModalActive: false,
        resetPasswordModalActive: false,
        routeParams: {},
        version: SetupService.packageData.version,
        credentials: {},
        isLoading: false
      }
    },
    methods: {
      isDanger (fieldName) {
        if (this.$validator.errors.has(fieldName)) return 'is-danger'
      },
      async login () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) return

        const loadingComponent = this.$loading.open()
        try {
          await AuthService.login(this.credentials)
          loadingComponent.close()

          this.$toast.open({
            message: 'Autenticado com sucesso.',
            type: 'is-success',
            duration: 5000
          })
          this.$router.push({name: 'Dashboard'})
        } catch (e) {
          loadingComponent.close()
          const message = (e.status === 422 || e.status === 404) ? 'Credenciais Inválidas!' : (e.status === 403) ? `Usuário Inativo!` : `Erro de servidor! ${JSON.stringify(e.body.error)}`
          this.$toast.open({
            message,
            type: 'is-danger',
            duration: 5000
          })
        }
      }
    },
    created () {
      this.routeParams = this.$route.params

      if (this.routeParams && this.routeParams.action) {
        switch (this.routeParams.action) {
          case 'update':
            this.resetPasswordModalActive = true
            break
        }
      }
    },
    computed: {
      validations () {
        return {
          username: {rules: {required: true, max: 1500}},
          password: {rules: {required: true, max: 1500}}
        }
      }
    }
  }
</script>

<style lang="sass">
  @import "~@/assets/sass/common.sass"
  section.login-section
    background: $main-bg
    .email-input,
    .password-input
      .input
        font-size: 20px
        color: #95A5A6
      .icon
        margin: 5px 10px

    .avatar img
      border-radius: 100px
      padding: 5px
      border: 1px solid #dbdbdb

    .forgot-password a
      color: #95A5A6
      font-weight: bold
      padding-right: 20px

    .login
      display: flex
      justify-content: center
      padding-top: 20px
      button
        font-weight: bold

    .hero-body .container
      background: white
      padding: 2rem
      border-radius: 3rem
      =desktop
        margin-top: -100px

    .hero.is-dark .section
      background-color: transparent

    .login-wrapper
      margin: -0.75rem
      overflow-y: hidden
      display: flex
      justify-content: center
    .column
      padding-bottom: 0

    .is-hom
      background: lighten($warning, 30%)
    .hero-banner
      .hero
        background-color: rgba(0,0,0,0.5)
        background-image: url('~@/assets/login-background.jpg')
        background-position: center
        background-size: cover
        background-blend-mode: hard-light
      .title
        display: inline-block
        background-color: rgba(0,0,0, 0.6)
        padding: 5px

</style>



// WEBPACK FOOTER //
// Auth.vue?28e4943c